import _globalThis2 from "../internals/global-this";
import _descriptors from "../internals/descriptors";
var exports = {};
var _globalThis = _globalThis2;
var DESCRIPTORS = _descriptors;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
exports = function (name) {
  if (!DESCRIPTORS) return _globalThis[name];
  var descriptor = getOwnPropertyDescriptor(_globalThis, name);
  return descriptor && descriptor.value;
};
export default exports;